import { render, staticRenderFns } from "./role__form.vue?vue&type=template&id=5c7891ca"
import script from "./role__form.vue?vue&type=script&lang=js"
export * from "./role__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports